




import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import autosize from 'autosize'

@Component
export default class AutosizeTextarea extends Vue {
  @Prop({ type: String, default: '' })
  value!: string

  internalValue = ''

  mounted() {
    autosize(this.$el)
    this.internalValue = this.value
  }
  beforeDestroy() {
    autosize.destroy(this.$el)
  }

  @Watch('value')
  onValueChange() {
    autosize.update(this.$el)
    this.internalValue = this.value
  }

  handleChange(e: { target: HTMLInputElement }) {
    this.$emit('input', e.target.value)
  }
}
